<template>
  <div class="static-page">
    <BasePreloader v-if="pending"/>
    <ErrorView v-else-if="error"/>
    <div v-else
         v-html="html">
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import ErrorView from '@/components/ErrorView'
  import globalMetaMixin from '@/mixins/globalMetaMixin'

  export default {
    name: 'StaticPage',
    mixins: [globalMetaMixin],
    components: {
      ErrorView
    },
    props: {
      pathToLoad: String
    },
    data() {
      return {
        pending: false,
        error: null,
        html: null,

        styles: [],
      }
    },
    methods: {
      load() {
        this.error = null
        this.pending = true

        http.get(this.pathToLoad)
          .then(({data}) => {
            this.html = data.html

            this.loadScripts(data.js)
            this.addStyles(data.css)
            this.setMetaTitleMixin(data.meta_title)
          })
          .catch(error => {
            this.error = {
              code: this.$get(error, 'response.status', 500),
              message: this.$get(error, 'response.data.message', error.message)
            }
          })
          .finally(() => {
            this.pending = false
          })
      },

      loadScripts(links) {
        if (!Array.isArray(links)) return

        links.forEach(link => {
          const script = document.createElement('script')
          script.setAttribute('type', 'text/javascript')
          script.setAttribute('charset', 'utf-8')
          script.setAttribute('src', link)
          document.body.appendChild(script)
          document.body.removeChild(script)
        })
      },

      addStyles(links) {
        if (!Array.isArray(links)) return

        links.forEach(link => {
          const style = document.createElement('link')
          style.setAttribute('rel', 'stylesheet')
          style.setAttribute('href', link)
          document.head.appendChild(style)

          this.styles.push(style)
        })
      },
      removeStyles() {
        this.styles.forEach(style => {
          document.head.removeChild(style)
        })
      }
    },
    created() {
      this.load()
    },
    beforeDestroy() {
      this.removeStyles()
    }
  }
</script>

<style lang="less">

</style>
